import { http } from 'services/http';
import type { TUpdateCargoCmrReceivedReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { CARGO_GET_ONE } from '../query-keys.ts';

export const useUpdateCargoCmrReceived = (cargoId: number) => {
  return useMutationBase<void, unknown, TUpdateCargoCmrReceivedReq>({
    mutationFn: async (variables) => {
      await http.patch(`/v1/cargo/${cargoId}/cmr`, variables);
    },

    invalidateCallback: () => [[CARGO_GET_ONE, cargoId]],
  });
};
